const Cart = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 22 22" fill="none">
      <path
        d="M1.82089 2.48926H3.30197C4.22125 2.48926 4.94476 3.28086 4.86816 4.19164L4.16167 12.6695C4.0425 14.0569 5.14053 15.2486 6.53648 15.2486H15.6017C16.8274 15.2486 17.8999 14.2442 17.9935 13.027L18.4532 6.64307C18.5553 5.2301 17.4828 4.08098 16.0613 4.08098H5.07245"
        stroke={color}
        strokeWidth="1.17857"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9509 19.5127C14.5385 19.5127 15.0149 19.0364 15.0149 18.4488C15.0149 17.8611 14.5385 17.3848 13.9509 17.3848C13.3633 17.3848 12.8869 17.8611 12.8869 18.4488C12.8869 19.0364 13.3633 19.5127 13.9509 19.5127Z"
        stroke={color}
        strokeWidth="1.17857"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.14186 19.5127C7.72949 19.5127 8.20585 19.0364 8.20585 18.4488C8.20585 17.8611 7.72949 17.3848 7.14186 17.3848C6.55424 17.3848 6.07787 17.8611 6.07787 18.4488C6.07787 19.0364 6.55424 19.5127 7.14186 19.5127Z"
        stroke={color}
        strokeWidth="1.17857"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.77974 7.5957H17.994"
        stroke={color}
        strokeWidth="1.17857"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default Cart;
